import * as React from "react";
import { LucideIcon } from "lucide-react";
import { ConditionalWrapper, cn } from "@/lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  leftIcon?: LucideIcon;
  rightIcon?: LucideIcon | any;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, leftIcon: LeftIcon, rightIcon: RightIcon, ...props }, ref) => {
    return (
      <ConditionalWrapper
        condition={!!(LeftIcon || RightIcon)}
        wrapper={(children) => (
          <label className="relative block w-full focus-within:text-gray-600">
            {LeftIcon && (
              <LeftIcon className="pointer-events-none absolute left-4 top-1/2 mr-2 h-4 w-4 -translate-y-1/2 transform text-gray-600" />
            )}
            {children}
            {RightIcon?.$$typeof?.toString() ===
            "Symbol(react.forward_ref)" ? (
              <RightIcon className="pointer-events-none absolute right-7 top-1/2 mr-2 h-4 w-4 -translate-y-1/2 transform text-gray-600" />
            ) : RightIcon ? (
              <div className="pointer-events-none absolute right-7 top-1/2 mr-2 h-4 w-4 -translate-y-1/2 text-xs text-muted-foreground">
                {RightIcon}
              </div>
            ) : null}
          </label>
        )}
      >
        <input
          type={type}
          className={cn(
            "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2",
            "text-sm ring-offset-background file:border-0 file:bg-transparent",
            "file:text-sm file:font-medium placeholder:text-muted-foreground",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
            "focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50",
            `${LeftIcon && "pl-10"}`,
            `${RightIcon && "mr-10"}`,
            className,
          )}
          ref={ref}
          {...props}
        />
      </ConditionalWrapper>
    );
  },
);
Input.displayName = "Input";

export { Input };
